import { TweenMax } from 'gsap';
import { hideCountry } from '../..';
import css from './aniComp.module.scss';
import KitL from './kitL';
import KitM from './kitM';
import ImgShowCard from './imgShowCard';
import ListC from './listC';
import ListD1 from './listD/listD1';
import ListD2 from './listD/listD2';
import Terms from './terms';
import { useGlobal } from '@/utils/useGlobal';
import { getImageLocal } from '@/utils/locals';
import ScrollStickyVideo from '@/components/ScrollStickyVideo';
import { handleDynamicPath } from '@/utils/handleDynamicPath';

export default function AniComp({ callBack, activeType }: any) {
    const { useEffect, useRouter } = useGlobal();
    const { locale } = useRouter();
    const imgLocale = getImageLocal(locale, ['cn', 'za']);
    const layoutH: number = typeof window !== 'undefined' ? window.innerHeight : 1042;
    const url = `/video/mm100/shot_${imgLocale}/`;

    // 第1个序列侦--放大
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.kitProduct .anicomp-sticky-out1', //触发元素
            offset: layoutH / 2, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '50%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.fromTo(
            ['.anicomp-sticky-out1 .anicomp-canvas', '.anicomp-sticky-out1 .VideoFramesPlayerBox'],
            0.4,
            {
                scale: 0.8,
                ease: 'none',
            },
            {
                scale: 1,
                ease: 'none',
            },
        );
        sceneA1.setTween(tweenA1);
        AniContainer.addScene(sceneA1);
    }, []);

    // 第1个序列侦--缩小
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.kitProduct .anicomp-sticky-out1', //触发元素
            offset: layoutH * 2, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '100%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.to('.anicomp-sticky-out1 .anicomp-canvas', 0.4, {
            opacity: 0,
            scale: 0.8,
            ease: 'none' as any,
        });
        sceneA1.setTween(tweenA1);
        AniContainer.addScene(sceneA1);
    }, []);
    // 第1个序列侦--end

    // 第2个序列侦--放大
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.kitProduct .anicomp-sticky-out2', //触发元素
            offset: layoutH / 2, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '50%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.fromTo(
            ['.anicomp-sticky-out2 .anicomp-canvas', '.anicomp-sticky-out2 .VideoFramesPlayerBox'],
            0.4,
            {
                scale: 0.8,
                ease: 'none',
            },
            {
                scale: 1,
                ease: 'none',
            },
        );
        sceneA1.setTween(tweenA1);
        AniContainer.addScene(sceneA1);
    }, []);

    // 第2个序列侦--缩小
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.kitProduct .anicomp-sticky-out2', //触发元素
            offset: layoutH * 2.5, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '100%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.to('.anicomp-sticky-out2 .anicomp-canvas', 0.4, {
            opacity: 0,
            scale: 0.8,
            ease: 'none' as any,
        });
        sceneA1.setTween(tweenA1);
        AniContainer.addScene(sceneA1);
    }, []);
    // 第2个序列侦--end

    // 第3个序列侦--放大
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.kitProduct .anicomp-sticky-out3', //触发元素
            offset: layoutH / 2, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '50%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.fromTo(
            ['.anicomp-sticky-out3 .anicomp-canvas', '.anicomp-sticky-out3 .VideoFramesPlayerBox'],
            0.4,
            {
                scale: 0.8,
                ease: 'none',
            },
            {
                scale: 1,
                ease: 'none',
            },
        );
        sceneA1.setTween(tweenA1);
        AniContainer.addScene(sceneA1);
    }, []);

    // 第3个序列侦--缩小
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.kitProduct .anicomp-sticky-out3', //触发元素
            offset: layoutH * 2.5, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '100%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.to('.anicomp-sticky-out3 .anicomp-canvas', 0.4, {
            opacity: 0,
            scale: 0.8,
            ease: 'none' as any,
        });
        sceneA1.setTween(tweenA1);
        AniContainer.addScene(sceneA1);
    }, []);
    // 第3个序列侦--end

    // 第4个序列侦--放大
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.kitProduct .anicomp-sticky-out4', //触发元素
            offset: layoutH / 2, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '50%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.fromTo(
            '.anicomp-sticky-out4 .anicomp-canvas',
            0.4,
            {
                scale: 0.8,
                ease: 'none',
            },
            {
                scale: 1,
                ease: 'none',
            },
        );
        sceneA1.setTween(tweenA1);
        AniContainer.addScene(sceneA1);
    }, []);

    // 第4个序列侦--缩小
    useEffect(() => {
        const sceneA1 = new ScrollMagic.Scene({
            triggerElement: '.kitProduct .anicomp-sticky-out4', //触发元素
            offset: layoutH * 2, //从开始点滚动多少px触发,可为负数
            triggerHook: 0, //触发元素开始进入视口时触发:1 进入,0 离开, 0.5 中间,
            duration: '100%', //和滚动条绑定到一起,场景持续滚动距离为 800px
        });
        const tweenA1 = TweenMax.to('.anicomp-sticky-out4 .anicomp-canvas', 0.4, {
            opacity: 0,
            scale: 0.8,
            ease: 'none' as any,
        });
        sceneA1.setTween(tweenA1);
        AniContainer.addScene(sceneA1);
    }, []);
    // 第4个序列侦--end

    return (
        <>
            <KitL callBack={callBack} />
            <div className={`${css.aniComp1} anicomp-sticky-out anicomp-sticky-out1`}>
                <div className="VideoFramesPlayerBox" style={{ marginTop: '-100vh' }}>
                    <ScrollStickyVideo
                        height={100}
                        delayRatio={1}
                        scrollRatio={2.5}
                        url={handleDynamicPath(`${url}shot1.mp4`)}
                        webmUrl={handleDynamicPath(`${url}shot1.webm`)}
                    />
                </div>
                <div className="anicomp-kitm-box">
                    <div className="product-white-border-bg1"></div>
                    <div className="anicomp-kitm-box-in">
                        <KitM callBack={callBack} />
                        <ImgShowCard />
                    </div>
                    <div className="product-white-border-bg2"></div>
                </div>
            </div>
            <div className={`${css.aniComp2} anicomp-sticky-out anicomp-sticky-out2`}>
                <div className="VideoFramesPlayerBox" style={{ marginTop: '-100vh' }}>
                    <ScrollStickyVideo
                        height={100}
                        delayRatio={1}
                        scrollRatio={2.5}
                        url={handleDynamicPath(`${url}shot2.mp4`)}
                        webmUrl={handleDynamicPath(`${url}shot2.webm`)}
                    />
                </div>
                <div className="anicomp-kitm-box">
                    <div className="product-white-border-bg1"></div>
                    <div className="anicomp-kitm-box-in">
                        <ListC callBack={callBack} type={activeType} />
                    </div>
                    <div className="product-white-border-bg2"></div>
                </div>
            </div>
            <div className={`${css.aniComp3} anicomp-sticky-out anicomp-sticky-out3`}>
                <div className="VideoFramesPlayerBox" style={{ marginTop: '-100vh' }}>
                    <ScrollStickyVideo
                        height={100}
                        delayRatio={1.5}
                        scrollRatio={2.5}
                        url={handleDynamicPath(`${url}shot3.mp4`)}
                        webmUrl={handleDynamicPath(`${url}shot3.webm`)}
                    />
                </div>
            </div>
            <div className={`${css.aniComp5} anicomp-sticky-out anicomp-sticky-out5`}>
                <ListD1 callBack={callBack} type={activeType} />
                <div className="product-white-border-bg2"></div>
            </div>
            <div className={`${css.aniComp4} anicomp-sticky-out anicomp-sticky-out4`}>
                <div className="VideoFramesPlayerBox" style={{ marginTop: '-100vh' }}>
                    <ScrollStickyVideo
                        height={100}
                        delayRatio={0.8}
                        scrollRatio={2.5}
                        url={handleDynamicPath(`${url}shot4.mp4`)}
                        webmUrl={handleDynamicPath(`${url}shot4.webm`)}
                    />
                </div>
            </div>
            <div className={`${css.aniComp6} anicomp-kitm-box`}>
                <div className="product-white-border-bg1"></div>
                <div className="anicomp-kitm-box-in">
                    <ListD2 callBack={callBack} />
                    {!hideCountry?.includes(locale) && (
                        <div className="terms-box">
                            <Terms />
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}
